import { proxy } from "valtio";

export const formEligibilityStore = proxy<{
  formEligibility?: any;
}>({
  formEligibility: undefined,
});
